import classNames from "classnames";
import React from "react";
import { useDispatch } from "react-redux";
import { setPopupComponent } from "../../store/slices/ui";

function PrivacyPolicy({ show }) {
  const dispatch = useDispatch();
  return (
    <div
      id="popup-policy"
      className={classNames("popup-container", { "show-popup": show })}
    >
      <div
        className="popup-content privacy-content"
        onBlur={() => dispatch(setPopupComponent(null))}
        tabIndex="1"
      >
        <a
          onClick={() => dispatch(setPopupComponent(null))}
          href="#"
          className="close"
        >
          &times;
        </a>
        <h3>Privacy Policy</h3>
        <div class="content-scroll-popup">
          <p>
            At ADoHScientific, we understand the importance of privacy and are
            committed to protecting the confidentiality and security of your
            data. This Privacy Policy outlines how we collect, use, disclose,
            and protect your information in accordance with applicable privacy
            laws and regulations. By using our services, you consent to the
            practices described in this Privacy Policy.
          </p>
          <p>
            <strong>Information We Collect:</strong>
          </p>
          <p>
            When providing our services in a healthcare setting we collect and
            store patient data necessary for providing these services. This may
            include but is not limited to name, date of birth, and email.
          </p>
          <p>
            In non-healthcare environments, we provide the ability the user our
            services anonymously. For those interested in tracking their scores
            over time, we provide the ability to sign up with social media
            account. We do not track any personal information about you. Your
            email is not shared with anyone.
          </p>
          <p>
            <strong>Purpose of personal data collection in healthcare.</strong>
          </p>
          <p>
            Healthcare provider: We use personal information to identify your
            data to the healthcare organization requesting our services and to
            communicate with you - when required.
          </p>
          <p>
            Research and public health: Anonymized patient data may be used for
            research or public health purposes, following applicable privacy
            safeguards.
          </p>
          <p>
            <strong>Data Security:</strong>
          </p>
          <p>
            We implement appropriate technical, administrative, and physical
            safeguards to protect patient data against unauthorized access,
            disclosure, alteration, or destruction. We regularly review our
            security measures and update them to ensure the ongoing
            confidentiality and integrity of patient information.
          </p>
          <p>
            <strong>Data Retention:</strong>
          </p>
          <p>
            We retain patient data for as long as necessary to fulfill the
            purposes outlined in this Privacy Policy, unless a longer retention
            period is required or permitted by law.
          </p>
          <p>
            <strong>Patient Rights:</strong>
          </p>
          <p>Patients have certain rights regarding their data, including:</p>
          <p>
            <strong>Contact Information:</strong>
          </p>
          <p>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or the handling of patient data, please contact us
            at 
            <a href="mailto:support@adohscientific.com">
              support@adohscientific.com
            </a>
            .
          </p>
          <p>
            By using our services, you acknowledge that you have read,
            understood, and agreed to the terms and conditions of this Privacy
            Policy.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
